export default __webpack_public_path__ + "static/media/P314 zu P207.2e3f5384.mp3";